// extracted by mini-css-extract-plugin
module.exports = {"outer_container":"TwitterSlider_outer_container__iVRRK","arrow":"TwitterSlider_arrow__ImKwQ","white_link":"TwitterSlider_white_link__JEJMg"};